import { privateAxios } from "@/common/api/axios";
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant";
import { Mapper } from "@/common/services/mapper";
import { MetaResponse } from "@/common/types/metaResponse";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

type UseClientCompaniesAvailableToAllocateInBranchSummaryProps<T> = {
  filters?: {
    search?: string
    page?: number
    productCategoryId?: string
  }
  mapper?: (data: any) => T
}

export const useClientCompaniesAvailableToAllocateInBranchSummary = <T,>({
  filters: { search = '', page, productCategoryId } = {},
  mapper = Mapper.default<T>(),
}: UseClientCompaniesAvailableToAllocateInBranchSummaryProps<T>) => {
  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    queryKey: ['clientCompaniesAvailableToAllocateInBranchesSummary', search, page, productCategoryId],
    queryFn: () => {
      return privateAxios.get(`/companies/available_to_allocate_in_branches_summary`, {
        params: {
          search,
          page,
          product_category_id: productCategoryId,
        }
      })
    },
    select: (data: { data: { data: any[], meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
  })

  return { data, meta, isPending, ...rest }
}
